import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const BUY_PACKAGE = 'BUY_PACKAGE';

export type TBuyPackageAction = IReduxAction<typeof BUY_PACKAGE>;

export const buyPackage = actionGenerator<typeof BUY_PACKAGE>(BUY_PACKAGE);
